import { createRouter, createWebHistory } from 'vue-router'
import AppRoutes from '@/modules/App/routes'
import UserRoutes from '@/modules/User/routes'
import ProjectRoutes from '@/modules/Project/routes'
import BudgetRoutes from '@/modules/Budget/routes'
import ProposalRouter from '@/modules/Proposal/routes'
import SettingRoutes from '@/modules/Settings/routes'
import CatalogRoutes from '@/modules/Catalog/routes'
import SubcontractorRoutes from '@/modules/Subcontractor/routes'
import CustomerRoutes from '@/modules/Customer/routes'
import VendorRoutes from '@/modules/Vendor/routes'
import PurchaseOrderRoutes from '@/modules/PurchaseOrder/routes'
import WorkOrderRoutes from '@/modules/WorkOrder/routes'
import BillRoutes from '@/modules/Bill/routes'
import InvoiceRoutes from '@/modules/Invoice/routes'
import { useAuth } from '@/composables/useAuth'

const routes = [
  ...AppRoutes,
  ...UserRoutes,
  ...ProjectRoutes,
  ...BudgetRoutes,
  ...ProposalRouter,
  ...SettingRoutes,
  ...CatalogRoutes,
  ...SubcontractorRoutes,
  ...CustomerRoutes,
  ...VendorRoutes,
  ...PurchaseOrderRoutes,
  ...WorkOrderRoutes,
  ...BillRoutes,
  ...InvoiceRoutes
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return Promise.resolve(savedPosition)
    } else {
      return Promise.resolve({ left: 0, top: 0 })
    }
  },
  routes
})

const isUserAuthorized = (authorizeRoles: string[], userRoles: string[]) => {
  return authorizeRoles.some(role => userRoles.includes(role))
}

router.beforeEach(async (to, from, next) => {
  const { authorize } = to.meta
  const { isAuthenticated, isAdmin, isVerified, userRoles } = useAuth()
  const redirectPath = router.currentRoute.value.query.redirect as string
  const toPath = router.currentRoute.value.fullPath
  let path = '/'

  if (redirectPath) {
    path = redirectPath
  } else if (toPath !== '/login' && toPath !== '/signup') {
    path = toPath
  }

  //1. if user is not authenticated not going to go Login or Singup, redirect to login
  if (!isAuthenticated.value && authorize) {
    return next({ name: 'Login' })
  }

  //2. if user is authenticated and going to Login or Singup, redirect to home
  if (isAuthenticated.value && (to.name === 'Login' || to.name === 'Signup')) {
    return next(path)
  }

  //3. user is authenticated but not verified, allow access to all routes but show verification banner
  if (isAuthenticated.value && !isVerified.value) {
    // Allow access to all routes but show verification banner
    if (authorize) {
      if (isAdmin.value) return next()

      if (Array.isArray(authorize) && authorize.length && !isUserAuthorized(authorize, userRoles.value)) {
        return next({ name: 'NotAuthorized' })
      }
    }
    return next()
  }

  //4. user is authenticated and verified, check if user is authorized to access the route
  if (authorize) {
    if (isAdmin.value) return next()

    if (Array.isArray(authorize) && authorize.length && !isUserAuthorized(authorize, userRoles.value)) {
      return next({ name: 'NotAuthorized' })
    }
  }

  next()
})

export default router
